import React, { createContext, useContext, useState } from "react";
const GooglePlaceContext = createContext();
export const GooglePlaceProvider = ({ children }) => {
  const [placeId, setPlaceId] = useState(null);

  return (
    <GooglePlaceContext.Provider value={{ placeId, setPlaceId }}>
      {children}
    </GooglePlaceContext.Provider>
  );
};
export const useGooglePlace = () => useContext(GooglePlaceContext);
